/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type faq_QueryVariables = {};
export type faq_QueryResponse = {
    readonly questions: ReadonlyArray<{
        readonly question: string;
        readonly answer: string;
        readonly isForCompanies: boolean;
    } | null> | null;
};
export type faq_Query = {
    readonly response: faq_QueryResponse;
    readonly variables: faq_QueryVariables;
};



/*
query faq_Query {
  questions {
    question
    answer
    isForCompanies
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isForCompanies",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "faq_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Question",
        "kind": "LinkedField",
        "name": "questions",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "faq_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Question",
        "kind": "LinkedField",
        "name": "questions",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "784f9c4f66f5dbc8e709d9987406f46f",
    "id": null,
    "metadata": {},
    "name": "faq_Query",
    "operationKind": "query",
    "text": "query faq_Query {\n  questions {\n    question\n    answer\n    isForCompanies\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c0399d9364f216701d0b3ee76411afd7';
export default node;
